module.exports = "/_next/static/images/golfWhite@3x-ec3f76495028c3b3613cdffe69ffb944.png";